/** Cliente de Checklist náutico — backend /geo/v1/checklists. */

export interface ChecklistItem { label: string; ok: boolean }

export interface Checklist {
  id: number;
  device_id: number;
  device_name: string;
  template: string;
  items: ChecklistItem[];
  note?: string | null;
  approved: boolean;
  created_by?: string | null;
  created_at?: string | null;
}

export interface ChecklistInput {
  device_id: number;
  device_name: string;
  template: string;
  items: ChecklistItem[];
  note?: string | null;
  approved: boolean;
}

const BASE = '/geo/v1/checklists';

async function req<T>(url: string, init?: RequestInit): Promise<T> {
  const r = await fetch(url, { credentials: 'include', ...init });
  if (!r.ok) throw new Error(`checklists ${r.status}`);
  if (r.status === 204) return undefined as T;
  return r.json() as Promise<T>;
}

export const checklistsApi = {
  list: () => req<Checklist[]>(BASE),
  create: (body: ChecklistInput) =>
    req<Checklist>(BASE, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }),
  remove: (id: number) => req<void>(`${BASE}/${id}`, { method: 'DELETE' }),
};

/** Modelos de checklist (estáticos). */
export const CHECKLIST_TEMPLATES: { key: string; label: string; items: string[] }[] = [
  { key: 'Saída', label: 'Saída', items: ['Coletes salva-vidas (quantidade)', 'Nível de combustível', 'Âncora e cabo', 'Rádio / comunicação', 'Luzes de navegação', 'Documentação a bordo', 'Extintor de incêndio', 'Casco sem avarias', 'Bomba de porão funcionando'] },
  { key: 'Retorno', label: 'Retorno', items: ['Combustível restante registrado', 'Avarias verificadas', 'Limpeza realizada', 'Equipamentos devolvidos', 'Âncora recolhida', 'Embarcação atracada com segurança'] },
  { key: 'Vistoria', label: 'Vistoria', items: ['Casco', 'Motor', 'Bateria', 'Bomba de porão', 'Coletes salva-vidas', 'Extintor', 'Sinalização', 'Documentação'] },
  { key: 'Segurança', label: 'Segurança', items: ['Coletes salva-vidas suficientes', 'Extintor válido', 'Kit de primeiros socorros', 'Rádio / VHF', 'Sinalizadores / foguetes', 'Boia salva-vidas'] },
];
